"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5302],{

/***/ 75302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _modules_common_components_underline_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16767);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var _lib_util_loader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44269);





var HeroElement = function(param) {
    var image = param.image, image2 = param.image2, alt = param.alt, alt2 = param.alt2, caption = param.caption, caption2 = param.caption2, title = param.title, subtitle = param.subtitle, cta = param.cta, _entranceAnimation = param.entranceAnimation, entranceAnimation = _entranceAnimation === void 0 ? false : _entranceAnimation;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("w-full text-neutral-900", "grid grid-cols-1 small:grid-cols-3 gap-0", {
                "bg-white grain-background": entranceAnimation
            }),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "z-10 pt-10 small:pt-0 flex flex-col justify-center text-center md:text-left px-10 md:p-32 gap-10",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "text-2xl md:text-3xl lg:text-4xl 2xl:text-5xl font-display font-base subpixel-antialiased",
                            children: title !== null && title !== void 0 ? title : ""
                        }),
                        cta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_common_components_underline_link__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            className: "uppercase",
                            href: cta.url,
                            children: cta.text
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "z-10 pt-[5vh] pr-2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative aspect-[2/1] small:aspect-[9/10] w-full",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "absolute z-10 text-white ml-10 mt-10 font-semibold text-lg",
                                children: caption !== null && caption !== void 0 ? caption : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        "Design &",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        " Duurzaam"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                loader: _lib_util_loader__WEBPACK_IMPORTED_MODULE_4__/* .ImageLoader */ .S,
                                src: image,
                                layout: "fill",
                                loading: "eager",
                                objectFit: "cover",
                                quality: 90,
                                priority: true,
                                alt: alt !== null && alt !== void 0 ? alt : "Welcome to AKU Panel",
                                className: "",
                                draggable: "false",
                                sizes: "(max-width: 400px) 100vw, (max-width: 800px) 100vw, 33vw",
                                placeholder: typeof image === "string" ? "empty" : "blur"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("z-10 flex flex-col content-start justify-center pl-2 gap-8 pt-10 small:pt-[12vh]"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-sm lg:text-base 2xl:text-lg w-full font-mono pl-[20%] pr-20 subpixel-antialiased",
                            children: subtitle !== null && subtitle !== void 0 ? subtitle : ""
                        }),
                        image2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative aspect-[2/1] small:aspect-square w-[80%] small:w-full self-end small:self-start",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "absolute z-10 text-white ml-10 mt-10 font-semibold text-lg",
                                    children: caption2 !== null && caption2 !== void 0 ? caption2 : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            "Robuust &",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            " Stijlvol"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    loader: _lib_util_loader__WEBPACK_IMPORTED_MODULE_4__/* .ImageLoader */ .S,
                                    src: image2 !== null && image2 !== void 0 ? image2 : "/hero.jpg",
                                    layout: "fill",
                                    loading: "eager",
                                    objectFit: "cover",
                                    quality: 90,
                                    priority: true,
                                    alt: alt2 !== null && alt2 !== void 0 ? alt2 : "Welcome to AKU Panel",
                                    className: "",
                                    draggable: "false",
                                    sizes: "(max-width: 400px) 100vw, (max-width: 800px) 100vw, 33vw",
                                    placeholder: typeof image2 === "string" ? "empty" : "blur"
                                })
                            ]
                        })
                    ]
                }),
                entranceAnimation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "absolute inset-x-0 bottom-0 top-[25vh] z-0 pointer-events-none",
                    style: {
                        background: "linear-gradient(\n" + "    to right,\n" + "    transparent 0%,\n" + "    transparent 33.33%,\n" + "    #f6f6f6 33.33%,\n" + "    #f6f6f6 100%\n" + "  )"
                    },
                    children: "\xa0"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (HeroElement);


/***/ }),

/***/ 16767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _modules_common_icons_arrow_right__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37233);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);




var UnderlineLink = function(param) {
    var href = param.href, children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex justify-center small:justify-start items-start",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: href,
            prefetch: false,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("flex items-center text-large-regular border-b border-darkTone gap-x-4 py-2 transition-all duration-300 group hover:text-highlight hover:pl-4 hover:pr-1", className !== null && className !== void 0 ? className : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "font-mono",
                        children: children
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_common_icons_arrow_right__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        size: 20,
                        className: "transition-all group-hover:ml-2 duration-300"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UnderlineLink);


/***/ })

}]);